/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

// componentes
import { Button } from '@design-system-coopeuch/web';

// styles
import StyledCaseInfo from './styles';

// assets
import iconPersonErrorMaleMobile from '../../../assets/img/icon-person-error-male-mobile.svg';
import iconPersonErrorMaleDesktop from '../../../assets/img/icon-person-error-male-desktop.svg';
import iconPersonWarningFemaleDesktop from '../../../assets/img/icon-person-warning-female-desktop.svg';
import iconPersonSuccessFemaleDesktop from '../../../assets/img/icon-person-success-female-desktop.svg';
import iconPersonInfoMaleDesktop from '../../../assets/img/icon-person-info-male-desktop.svg';
import iconPersonMaleBiometryError from '../../../assets/img/icon-person-biometry-male-error.svg';

const CaseInfo = (props) => {
  const { edgeCase, isMobile, onClickLink, onClickButton } = props;

  const icons = {
    iconPersonError: isMobile ? iconPersonErrorMaleMobile : iconPersonErrorMaleDesktop,
    iconPersonWarning: iconPersonWarningFemaleDesktop,
    iconPersonSuccess: iconPersonSuccessFemaleDesktop,
    iconPersonInfo: iconPersonInfoMaleDesktop,
    iconPersonBiometry: iconPersonMaleBiometryError,
    iconPersonBiometryError: iconPersonMaleBiometryError,
  };

  return (
    <StyledCaseInfo className="">
      <section className="pt-7 px-7 pb-5 d-flex flex-column justify-content-center align-items-center">
        <img src={icons[edgeCase.icon]} alt="" />
        <h4 className="text-color-38">{edgeCase.title}</h4>
        <p className="text-color-38">{edgeCase.message}</p>
      </section>
      <article className="w-100 p-5 border-top border-neutral-alfa-15">
        {/* // // eslint-disable-next-line react/prop-types */}
        <Button color={edgeCase.actionButton.class} onClick={onClickButton} variant="default">
          {edgeCase.actionButton.text}
        </Button>
        {/* // // eslint-disable-next-line react/prop-types */}
        {edgeCase.actionLink && edgeCase.actionLink.text !== '' && (
          <Button
            color="primary"
            disabled={false}
            onClick={onClickLink}
            prefix={null}
            suffix={null}
            variant="text"
          >
            {edgeCase.actionLink.text}
          </Button>
        )}
      </article>
    </StyledCaseInfo>
  );
};
/* istanbul ignore next */
CaseInfo.defaultProps = {
  edgeCase: {},
  isMobile: false,
  onClickLink: () => null,
  onClickButton: () => null,
};

CaseInfo.propTypes = {
  edgeCase: PropTypes.shape({}),
  isMobile: PropTypes.bool,
  onClickLink: PropTypes.func,
  onClickButton: PropTypes.func,
};

export default CaseInfo;
